export const HttpRegex = /^((http|https):\/\/)/;
